<template>
  <div class="mobile-layout">
    <header class="mobile-header glass" role="banner">
      <div class="left">
        <button ref="hamburger" class="hamburger icon-btn" @click="menuOpen = !menuOpen" aria-label="Main menu">☰</button>
      </div>

      <div class="title-wrapper">
        <div class="title" role="heading" aria-level="1">GDS API Demo</div>
        <div class="subtitle" v-if="currentTitle && currentTitle !== 'Home'">{{ currentTitle }}</div>
      </div>

      <div class="right">
        <button v-if="!isLoggedIn" class="icon-btn" aria-label="Login" @click="$router.push('/mobile/login')">🔑</button>
        <button v-else class="icon-btn" aria-label="Profile" @click="$router.push('/mobile')">👤</button>
      </div>
    </header>

    <div v-if="menuOpen" class="menu-drawer" @click.self="menuOpen = false" role="dialog" aria-modal="true" aria-labelledby="drawer-title">
      <div class="drawer" tabindex="-1">
        <h3 id="drawer-title" class="sr-only">Mobile menu</h3>
        <button ref="drawerClose" class="close" @click="menuOpen = false" aria-label="Close menu">✕</button>
        <ul>
          <li><router-link @click="menuOpen = false" to="/mobile">Home</router-link></li>
          <li v-if="!isLoggedIn"><router-link @click="menuOpen = false" to="/mobile/login">Login</router-link></li>
          <li v-else><a href="#" @click.prevent="mobileLogout">Logout</a></li>
          <li v-if="isLoggedIn"><router-link @click="menuOpen = false" to="/mobile/dashboard1">Dashboard1</router-link></li>
          <li v-if="isLoggedIn"><router-link @click="menuOpen = false" to="/mobile/dashboard2">Dashboard2</router-link></li>
          <li v-if="isLoggedIn"><router-link @click="menuOpen = false" to="/mobile/dashboard3">Dashboard3</router-link></li>
          <li v-if="isLoggedIn"><router-link @click="menuOpen = false" to="/mobile/dashboard4">Dashboard4</router-link></li>
          <li v-if="isLoggedIn"><router-link @click="menuOpen = false" to="/mobile/dashboard5">Dashboard5</router-link></li>
          <li v-if="isLoggedIn"><router-link @click="menuOpen = false" to="/mobile/dashboard6">Dashboard6</router-link></li>
          <li v-if="isLoggedIn"><router-link @click="menuOpen = false" to="/mobile/dashboard7">Dashboard7</router-link></li>
          <li><router-link @click="menuOpen = false" to="/">Desktop</router-link></li>
        </ul>
      </div>
    </div>

    <main class="mobile-body">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'Mobile',
  data(){ return { menuOpen: false } },
  computed: {
    isLoggedIn(){ return this.$store.state.auth.status.loggedIn },
    currentTitle(){
      const map = {
        HomeMobile: 'Home',
        Dashboard1Mobile: 'Dashboard 1',
        Dashboard2Mobile: 'Dashboard 2',
        Dashboard3Mobile: 'Dashboard 3',
        Dashboard4Mobile: 'Dashboard 4',
        Dashboard5Mobile: 'Dashboard 5',
        Dashboard6Mobile: 'Dashboard 6',
        Dashboard7Mobile: 'Dashboard 7',
        LoginMobile: 'Login',
        Home: 'Home',
        Dashboard1: 'Dashboard 1',
        Dashboard2: 'Dashboard 2',
        Dashboard3: 'Dashboard 3',
        Dashboard4: 'Dashboard 4',
        Dashboard5: 'Dashboard 5',
        Dashboard6: 'Dashboard 6',
        Dashboard7: 'Dashboard 7',
        Login: 'Login'
      };
      const name = this.$route && this.$route.name ? this.$route.name : '';
      return map[name] || (this.$route && this.$route.path && this.$route.path.startsWith('/mobile') ? 'Home' : '');
    }
  },
  watch: {
    menuOpen(newVal){
      this.$nextTick(() => {
        if (newVal) {
          if (this.$refs.drawerClose) this.$refs.drawerClose.focus();
        } else {
          if (this.$refs.hamburger) this.$refs.hamburger.focus();
        }
      });
    }
  },
  methods: {
    handleKeydown(e){ if (e.key === 'Escape' && this.menuOpen) this.menuOpen = false },
    mobileLogout(){
      this.$store.dispatch('auth/logout');
      this.menuOpen = false;
      this.$router.push('/mobile/login');
    }
  },
  mounted(){ document.addEventListener('keydown', this.handleKeydown); },
  beforeUnmount(){ document.removeEventListener('keydown', this.handleKeydown); }
};
</script>

<style scoped>
.mobile-layout { font-family: Arial, Helvetica, sans-serif; }
.mobile-header {
  position: sticky;
  top: 0;
  z-index: 40;
  display: grid;
  grid-template-columns: 56px 1fr 56px;
  align-items: center;
  gap: 8px;
  padding: calc(env(safe-area-inset-top, 0) + 8px) 12px 8px;
}

/* Glass effect */
.mobile-header.glass {
  background: rgba(255,255,255,0.62);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0,0,0,0.06);
  color: #07202a;
}

.mobile-header .left{ display:flex; align-items:center; justify-content:flex-start }
.icon-btn{ width:44px; height:44px; display:inline-flex; align-items:center; justify-content:center; border-radius:10px; border:none; background:transparent; cursor:pointer; font-size:18px }
.icon-btn:focus{ outline: 3px solid rgba(0,90,158,0.15); outline-offset:2px }
.hamburger{ font-size:18px; background:transparent; border:none }
.mobile-header .title { font-weight:700; font-size:16px; text-align:center; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; pointer-events:none }.mobile-header .title-wrapper { display:flex; flex-direction:column; align-items:center; justify-content:center }
.mobile-header .subtitle { font-size:12px; color: rgba(7,32,42,0.7); margin-top:2px }.mobile-header .right{ display:flex; align-items:center; justify-content:flex-end }
.mobile-header nav a { color: #07202a; margin-left:8px; text-decoration:none; }

/* Fallback when backdrop-filter not supported */
@supports not ((-webkit-backdrop-filter: blur(8px)) or (backdrop-filter: blur(8px))) {
  .mobile-header.glass { background: rgba(255,255,255,0.95) }
}

@media (max-width: 420px) {
  .mobile-header { grid-template-columns: 48px 1fr 48px; padding: calc(env(safe-area-inset-top, 0) + 6px) 10px 6px }
  .mobile-header .title { font-size:15px }
}
.menu-drawer{ position:fixed; inset:0; background:rgba(0,0,0,0.4); display:flex; justify-content:flex-end; z-index:9999 }
.drawer{ width:260px; background:#fff; padding:12px; height:100%; position:relative; z-index:10000 }
.drawer .close{ float:right; border:none; background:transparent; font-size:18px }
.drawer ul{ list-style:none; padding:0; margin-top:20px }
.drawer li{ padding:8px 0 }
.mobile-body { padding: 10px; }

/* Accessibility helpers */
.sr-only { position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0 0 0 0); white-space:nowrap; border:0 }
:focus-visible { outline: 3px solid #005a9e; outline-offset: 2px }

/* Ensure all focusable controls follow focus-visible */
button:focus, a:focus, input:focus { outline: none }
</style>

<style>
:root{
  /* Global mobile design tokens (compact) */
  --mobile-font-family: Arial, Helvetica, sans-serif;
  --mobile-font-size: 13px;
  --mobile-line-height: 1.2;
  --mobile-card-padding: 8px;

  --compact-table-font-size: 13px;
  --compact-table-cell-padding: 6px;
  --compact-table-border: #e6e9ec;
  --compact-table-section-bg: #f6f7f9;
  --compact-table-zebra: #fbfcfd;
  --compact-number-color: #17202a;
}

/* Compact table utilities */
/* Global visually-hidden utility for captions and labels */
.sr-only { position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0 0 0 0); white-space:nowrap; border:0 }

.compact-table-wrapper{ overflow-x:auto; -webkit-overflow-scrolling:touch }
.compact-table{ width:100%; border-collapse:separate; border-spacing:0; min-width:0; table-layout:auto; font-size:var(--compact-table-font-size) }
.compact-table th, .compact-table td{ padding:var(--compact-table-cell-padding); border:0; vertical-align:middle }
.compact-table thead th{ font-weight:600; text-align:left; border-bottom:1px solid var(--compact-table-border); }
.compact-table tbody tr{ border-bottom:1px solid var(--compact-table-border); }
.compact-table tbody tr:nth-child(odd){ background:var(--compact-table-zebra); }
.compact-table td.number, .compact-table .num{ text-align:right; color:var(--compact-number-color); font-variant-numeric:tabular-nums }
.compact-table .section td{ background:var(--compact-table-section-bg); font-weight:600 }
.nowrap-ellipsis{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:160px; display:inline-block }

/* Page overflow guard: prevent page-level horizontal scroll by keeping wide elements contained */
.mobile-body, .mobile-layout{ overflow-x:hidden }
img, iframe, video{ max-width:100%; height:auto }
</style> 
